"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserLanguage = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
// adapted from https://gist.github.com/Josantonius/b455e315bc7f790d14b136d61d9ae469
exports.BrowserLanguage = (0, type_utils_1.makeEnum)({
    '(Afan)/Oromoor/Oriya': 'om',
    Abkhazian: 'ab',
    Afar: 'aa',
    Afrikaans: 'af',
    Albanian: 'sq',
    Amharic: 'am',
    'Arabic (Algeria)': 'ar-DZ',
    'Arabic (Bahrain)': 'ar-BH',
    'Arabic (Egypt)': 'ar-EG',
    'Arabic (Iraq)': 'ar-IQ',
    'Arabic (Jordan)': 'ar-JO',
    'Arabic (Kuwait)': 'ar-KW',
    'Arabic (Lebanon)': 'ar-LB',
    'Arabic (libya)': 'ar-LY',
    'Arabic (Morocco)': 'ar-MA',
    'Arabic (Oman)': 'ar-OM',
    'Arabic (Qatar)': 'ar-QA',
    'Arabic (Saudi Arabia)': 'ar-SA',
    'Arabic (Syria)': 'ar-SY',
    'Arabic (Tunisia)': 'ar-TN',
    'Arabic (U.A.E.)': 'ar-AE',
    'Arabic (Yemen)': 'ar-YE',
    Arabic: 'ar',
    Armenian: 'hy',
    Assamese: 'as',
    Aymara: 'ay',
    Azeri: 'az',
    Bashkir: 'ba',
    Basque: 'eu',
    Belarusian: 'be',
    Bengali: 'bn',
    Bhutani: 'dz',
    Bihari: 'bh',
    Bislama: 'bi',
    Breton: 'br',
    'Bulgarian (Bulgaria)': 'bg-BG',
    Bulgarian: 'bg',
    Burmese: 'my',
    Cambodian: 'km',
    Catalan: 'ca',
    'Chinese (China)': 'zh-CN',
    'Chinese (Hong Kong SAR)': 'zh-HK',
    'Chinese (Macau SAR)': 'zh-MO',
    'Chinese (Singapore)': 'zh-SG',
    'Chinese (Taiwan)': 'zh-TW',
    Chinese: 'zh',
    Corsican: 'co',
    'Croatian (Croatia)': 'hr-HR',
    Croatian: 'hr',
    'Czech (Czech Republic)': 'cs-CZ',
    Czech: 'cs',
    'Danish (Denmark)': 'da-DK',
    Danish: 'da',
    Divehi: 'div',
    'Dutch (Belgium)': 'nl-BE',
    'Dutch (Netherlands)': 'nl-NL',
    Dutch: 'nl',
    'English (Australia)': 'en-AU',
    'English (Belize)': 'en-BZ',
    'English (Canada)': 'en-CA',
    'English (Ireland)': 'en-IE',
    'English (Jamaica)': 'en-JM',
    'English (New Zealand)': 'en-NZ',
    'English (Philippines)': 'en-PH',
    'English (South Africa)': 'en-ZA',
    'English (Switzerland)': 'en-CH',
    'English (Trinidad)': 'en-TT',
    'English (United Kingdom)': 'en-GB',
    'English (United States)': 'en-US',
    'English (Zimbabwe)': 'en-ZW',
    English: 'us',
    Esperanto: 'eo',
    Estonian: 'et',
    'Estonian (Estonia)': 'et-EE',
    Faeroese: 'fo',
    Farsi: 'fa',
    Fiji: 'fj',
    'Finnish (Finland)': 'fi-FI',
    Finnish: 'fi',
    'French (Belgium)': 'fr-BE',
    'French (Canada)': 'fr-CA',
    'French (France)': 'fr-FR',
    'French (Luxembourg)': 'fr-LU',
    'French (Monaco)': 'fr-MC',
    'French (Switzerland)': 'fr-CH',
    French: 'fr',
    Frisian: 'fy',
    'FYRO Macedonian': 'mk',
    Gaelic: 'gd',
    Galician: 'gl',
    Georgian: 'ka',
    'German (Austria)': 'de-AT',
    'German (Germany)': 'de-DE',
    'German (Liechtenstein)': 'de-LI',
    'German (Luxembourg)': 'de-LU',
    'German (Switzerland)': 'de-CH',
    German: 'de',
    'Greek (Greece)': 'el-GR',
    Greek: 'el',
    Greenlandic: 'kl',
    Guarani: 'gn',
    Gujarati: 'gu',
    Hausa: 'ha',
    Hebrew: 'iw',
    Hindi: 'hi',
    'Hungarian (Hungary)': 'hu-HU',
    Hungarian: 'hu',
    Icelandic: 'is',
    'Icelandic (Iceland)': 'is-IS',
    Indonesian: 'in',
    Interlingua: 'ia',
    Interlingue: 'ie',
    Inupiak: 'ik',
    Irish: 'ga',
    'Irish (Ireland)': 'ga-IE',
    'Italian (Italy)': 'it-IT',
    'Italian (Switzerland)': 'it-CH',
    Italian: 'it',
    Japanese: 'ja',
    Javanese: 'jw',
    Kannada: 'kn',
    Kashmiri: 'ks',
    Kazakh: 'kk',
    Kinyarwanda: 'rw',
    Kirghiz: 'ky',
    Kirundi: 'rn',
    Konkani: 'kok',
    Korean: 'ko',
    Kurdish: 'ku',
    Kyrgyz: 'kz',
    Laothian: 'lo',
    Latin: 'la',
    Latvian: 'lv',
    'Latvian (Latvia)': 'lv-LV',
    Lingala: 'ln',
    'Lithuanian (Lithuania)': 'lt-LT',
    Lithuanian: 'lt',
    Malagasy: 'mg',
    Malay: 'ms',
    Malayalam: 'ml',
    Maltese: 'mt',
    'Maltese (Malta)': 'mt-MT',
    Maori: 'mi',
    Marathi: 'mr',
    Moldavian: 'mo',
    Mongolian: 'mn',
    Nauru: 'na',
    'Nepali (India)': 'ne',
    Norwegian: 'no',
    'Norwegian Bokmål': 'nb',
    'Norwegian Nynorsk': 'nn',
    'Norwegian (Norway)': 'no-NO',
    'Norwegian Bokmål (Norway)': 'nb-NO',
    'Norwegian Nynorsk (Norway)': 'nn-NO',
    Occitan: 'oc',
    Oriya: 'or',
    'Pashto/Pushto': 'ps',
    'Polish (Poland)': 'pl-PL',
    Polish: 'pl',
    'Portuguese (Brazil)': 'pt-BR',
    'Portuguese (Portugal)': 'pt-PT',
    'Portuguese (Switzerland)': 'pt-CH',
    Portuguese: 'pt',
    Punjabi: 'pa',
    Quechua: 'qu',
    'Rhaeto-Romanic': 'rm',
    'Romanian (Moldova)': 'ro-MD',
    'Romanian (Romania)': 'ro-RO',
    Romanian: 'ro',
    'Russian (Moldova)': 'ru-MD',
    Russian: 'ru',
    Samoan: 'sm',
    Sangro: 'sg',
    Sanskrit: 'sa',
    Serbian: 'sr',
    'Serbo-Croatian': 'sh',
    Sesotho: 'st',
    Shona: 'sn',
    Sindhi: 'sd',
    Singhalese: 'si',
    Siswati: 'ss',
    Slovak: 'sk',
    'Slovak (Slovakia)': 'sk-SK',
    Slovenian: 'sl',
    'Slovenian (Slovenia)': 'sl-SI',
    Somali: 'so',
    Sorbian: 'sb',
    'Spanish (Argentina)': 'es-AR',
    'Spanish (Bolivia)': 'es-BO',
    'Spanish (Chile)': 'es-CL',
    'Spanish (Colombia)': 'es-CO',
    'Spanish (Costa Rica)': 'es-CR',
    'Spanish (Dominican Republic)': 'es-DO',
    'Spanish (Ecuador)': 'es-EC',
    'Spanish (El Salvador)': 'es-SV',
    'Spanish (Espa\u00f1a)': 'es-ES',
    'Spanish (Guatemala)': 'es-GT',
    'Spanish (Honduras)': 'es-HN',
    'Spanish (Mexico)': 'es-MX',
    'Spanish (Nicaragua)': 'es-NI',
    'Spanish (Panama)': 'es-PA',
    'Spanish (Paraguay)': 'es-PY',
    'Spanish (Peru)': 'es-PE',
    'Spanish (Puerto Rico)': 'es-PR',
    'Spanish (United States)': 'es-US',
    'Spanish (Uruguay)': 'es-UY',
    'Spanish (Venezuela)': 'es-VE',
    Spanish: 'es',
    Sundanese: 'su',
    Sutu: 'sx',
    Swahili: 'sw',
    'Swedish (Finland)': 'sv-FI',
    'Swedish (Sweden)': 'sv-SE',
    Swedish: 'sv',
    'Swiss German': 'gsw',
    'Swiss German (Liechtenstein)': 'gsw-LI',
    'Swiss German (Switzerland)': 'gsw-CH',
    Syriac: 'syr',
    Tagalog: 'tl',
    Tajik: 'tg',
    Tamil: 'ta',
    Tatar: 'tt',
    Telugu: 'te',
    Thai: 'th',
    Tibetan: 'bo',
    Tigrinya: 'ti',
    Tonga: 'to',
    Tsonga: 'ts',
    Tswana: 'tn',
    Turkish: 'tr',
    Turkmen: 'tk',
    Twi: 'tw',
    Ukrainian: 'uk',
    Urdu: 'ur',
    Uzbek: 'uz',
    Vietnamese: 'vi',
    Volapuk: 'vo',
    Welsh: 'cy',
    Wolof: 'wo',
    Xhosa: 'xh',
    Yiddish: 'yi',
    Yoruba: 'yo',
    Zulu: 'zu',
});
//# sourceMappingURL=browserLanguage.js.map